<template>
  <div class="row">
    <div class="flex xs10 offset--xs1">
      <va-card title="数据源详情">
        <div class="row">
          <!-- 基本信息 -->
          <div class="flex md12">
            <va-button flat disabled color="primary" style="font-size: 16px; font-weight: bold;">基本信息</va-button>
          </div>
          <div class='flex md4 sm6 xs12'>
            <va-input v-model='dataSource.id' label='数据源ID' disabled />
          </div>
          <div class='flex md4 sm6 xs12'>
            <va-input v-model='dataSource.name' label='数据源名称' disabled />
          </div>
          <div class='flex md4 sm6 xs12'>
            <va-input v-model='dataSource.siteCategoryText' label='网站分类' disabled />
          </div>
          <div class='flex md6 sm6 xs12'>
            <va-input v-model='dataSource.siteUrl' label='站点URL' disabled />
          </div>
          <div class='flex md6 sm6 xs12'>
            <va-input v-model='dataSource.atsPlatformName' label='ATS平台名称' disabled />
          </div>
          <div class='flex md12 sm6 xs12'>
            <va-input v-model='dataSource.description' label='描述信息' disabled />
          </div>
          <div class='flex md12 sm6 xs12'>
            <va-input v-model='dataSource.tags' label='标签' disabled />
          </div>

          <!-- 关联信息 -->
          <div class="flex md12">
            <va-divider />
            <va-button flat disabled color="primary" style="font-size: 16px; font-weight: bold;">关联信息</va-button>
          </div>
          <div class='flex md6 sm6 xs12'>
            <va-input v-model='dataSource.organizationId' label='关联公司ID' disabled />
          </div>
          <div class='flex md6 sm6 xs12'>
            <va-input v-model='dataSource.organizationName' label='关联公司名称' disabled />
          </div>
          <div class='flex md6 sm6 xs12'>
            <va-input v-model='dataSource.createdBy' label='爬虫项目名称' disabled />
          </div>

          <!-- 爬取状态 -->
          <div class="flex md12">
            <va-divider />
            <va-button flat disabled color="primary" style="font-size: 16px; font-weight: bold;">爬取状态</va-button>
          </div>
          <div class='flex md4 sm6 xs12'>
            <va-input v-model='dataSource.crawlStatusText' label='爬取状态' disabled>
              <template v-if="dataSource.crawlStatus !== null">
                <va-badge slot="prepend" :color="computeCrawlStatusColor(dataSource.crawlStatus)">
                  {{ dataSource.crawlStatusText }}
                </va-badge>
              </template>
            </va-input>
          </div>
          <div class='flex md4 sm6 xs12'>
            <va-input v-model='dataSource.lastSuccessTimeText' label='最后成功爬取时间' disabled />
          </div>
          <div class='flex md4 sm6 xs12'>
            <va-input v-model='dataSource.failureReasonText' label='失败原因' disabled />
          </div>
          <div class='flex md12 sm6 xs12'>
            <va-input v-model='dataSource.failureMessage' label='失败详细信息' disabled />
          </div>

          <!-- 时间信息 -->
          <div class="flex md12">
            <va-divider />
            <va-button flat disabled color="primary" style="font-size: 16px; font-weight: bold;">时间信息</va-button>
          </div>
          <div class='flex md6 sm6 xs12'>
            <va-input v-model='dataSource.createTimeText' label='创建时间' disabled />
          </div>
          <div class='flex md6 sm6 xs12'>
            <va-input v-model='dataSource.updateTimeText' label='更新时间' disabled />
          </div>
        </div>

        <div class="flex md3 offset--md4 mt-3">
          <va-button class="ma-0" color="gray" @click="goBack">
            返回列表
          </va-button>
        </div>
      </va-card>
    </div>
  </div>
</template>

<script>
import dataSourceApi from '../../api/dataSource'

export default {
  data() {
    return {
      dataSource: {
        id: null,
        name: '',
        siteUrl: '',
        siteCategory: null,
        siteCategoryText: '',
        description: '',
        tags: '',
        organizationId: null,
        organizationName: '',
        atsPlatformName: '',
        createdBy: '',
        crawlStatus: null,
        crawlStatusText: '',
        lastSuccessTime: null,
        lastSuccessTimeText: '',
        failureReason: null,
        failureReasonText: '',
        failureMessage: '',
        createTime: null,
        createTimeText: '',
        updateTime: null,
        updateTimeText: '',
      },
    }
  },
  created() {
    this.getDataSource()
  },
  methods: {
    getDataSource() {
      const id = this.$route.params.id
      if (!id) {
        this.showToast('数据源ID不存在', {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
        this.$router.push({ name: 'listDataSource' })
        return
      }

      dataSourceApi.getDataSource(id).then(response => {
        const ds = response.dataSource
        this.dataSource.id = ds.id
        this.dataSource.name = ds.name || ''
        this.dataSource.siteUrl = ds.siteUrl || ''
        this.dataSource.siteCategory = ds.siteCategory !== undefined && ds.siteCategory !== null ? ds.siteCategory : null

        // 网站分类文本
        const categoryMap = { 0: '未分类', 1: 'ATS系统', 2: '公司招聘页', 3: '聚合网站' }
        this.dataSource.siteCategoryText = categoryMap[ds.siteCategory] !== undefined ? categoryMap[ds.siteCategory] : '未知'

        this.dataSource.description = ds.description || ''
        this.dataSource.tags = ds.tags || ''
        this.dataSource.organizationId = ds.organizationId || null
        this.dataSource.organizationName = ds.organizationName || ''
        this.dataSource.atsPlatformName = ds.atsPlatformName || ''
        this.dataSource.createdBy = ds.createdBy || ''
        this.dataSource.crawlStatus = ds.crawlStatus !== undefined && ds.crawlStatus !== null ? ds.crawlStatus : null

        // 爬取状态文本
        const statusMap = { 0: '未爬取', 10: '已调度', 20: '爬取中', 30: '解析中', 1: '成功', 2: '本轮无岗位', 3: '失败' }
        this.dataSource.crawlStatusText = statusMap[ds.crawlStatus] !== undefined ? statusMap[ds.crawlStatus] : '未知'

        this.dataSource.lastSuccessTime = ds.lastSuccessTime || null
        // 处理秒级时间戳
        const lastSuccessTimestamp = ds.lastSuccessTime && ds.lastSuccessTime.toString().length === 10 ? ds.lastSuccessTime * 1000 : ds.lastSuccessTime
        this.dataSource.lastSuccessTimeText = lastSuccessTimestamp ? new Date(lastSuccessTimestamp).toLocaleString('zh-CN') : '无'

        this.dataSource.failureReason = ds.failureReason !== undefined && ds.failureReason !== null ? ds.failureReason : null

        // 失败原因文本
        const failureMap = { 0: '无', 1: '反爬', 2: '人机验证', 3: '需要登录', 4: '其他', 5: '数据源无岗位', 6: '限流(429)' }
        this.dataSource.failureReasonText = failureMap[ds.failureReason] !== undefined ? failureMap[ds.failureReason] : '未知'

        this.dataSource.failureMessage = ds.failureMessage || ''
        this.dataSource.createTime = ds.createTime || null
        // 处理秒级时间戳
        const createTimestamp = ds.createTime && ds.createTime.toString().length === 10 ? ds.createTime * 1000 : ds.createTime
        this.dataSource.createTimeText = createTimestamp ? new Date(createTimestamp).toLocaleString('zh-CN') : '无'
        this.dataSource.updateTime = ds.updateTime || null
        // 处理秒级时间戳
        const updateTimestamp = ds.updateTime && ds.updateTime.toString().length === 10 ? ds.updateTime * 1000 : ds.updateTime
        this.dataSource.updateTimeText = updateTimestamp ? new Date(updateTimestamp).toLocaleString('zh-CN') : '无'
      }).catch(error => {
        this.showToast(error.msg || '获取数据源详情失败', {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
        this.$router.push({ name: 'listDataSource' })
      })
    },
    computeCrawlStatusColor(status) {
      const colorMap = {
        0: 'gray',
        10: 'info',
        20: '#F57C00',
        30: 'primary',
        1: 'success',
        2: '#795548',
        3: 'danger',
      }
      return colorMap[status] || 'gray'
    },
    goBack() {
      this.$router.push({ name: 'listDataSource' })
    },
  },
}
</script>
